import HttpServiceBase from "./http-service";

export default class CertificationComplianceService extends HttpServiceBase {
  public async getCertificationCompliance(
    periodYear: number,
    entityId: number
  ): Promise<CertificationCompliance[]> {
    const { data } = await this.httpClient.get<CertificationCompliance[]>(
      "/certification-compliance",
      { params: { period_year: periodYear, entity_id: entityId } }
    );
    return data;
  }

  public getCertificationComplianceExportLink(
    periodYear: number,
    entityId: number
  ): string {
    const base = this.httpClient.defaults.baseURL ?? "";
    return `${base}/certification-compliance/export?entity_id=${entityId}&period_year=${periodYear}`;
  }
}

export interface CertificationCompliance {
  entity_id: number;
  percentage: number;
  month: string;
  compliance_score: number;
  documentation_count: number;
}
